var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.04 23.499c6.351 0 11.5-5.149 11.5-11.5S18.391.499 12.04.499.54 5.648.54 11.999s5.149 11.5 11.5 11.5z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.434 8.446A.569.569 0 008.54 9v7a.57.57 0 00.894.553l7.212-3.606c.491-.246.491-.648 0-.894L9.434 8.446z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuMDQgMjMuNDk5QzE4LjM5MTMgMjMuNDk5IDIzLjU0IDE4LjM1MDMgMjMuNTQgMTEuOTk5QzIzLjU0IDUuNjQ3NzUgMTguMzkxMyAwLjQ5OTAyMyAxMi4wNCAwLjQ5OTAyM0M1LjY4ODc2IDAuNDk5MDIzIDAuNTQwMDM5IDUuNjQ3NzUgMC41NDAwMzkgMTEuOTk5QzAuNTQwMDM5IDE4LjM1MDMgNS42ODg3NiAyMy40OTkgMTIuMDQgMjMuNDk5WiIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS40MzQyNyA4LjQ0NjAzQzkuMjQ3MzggOC4zMTE0MyA4Ljk5Nzc5IDguMzAyNzcgOC44MDIwMiA4LjQyNDA4QzguNjA2MjUgOC41NDU0IDguNTAyOTIgOC43NzI3NyA4LjU0MDI3IDkuMDAwMDNWMTZDOC41MDM0MiAxNi4yMjcxIDguNjA2OTQgMTYuNDU0MSA4LjgwMjU5IDE2LjU3NTFDOC45OTgyNSAxNi42OTYxIDkuMjQ3NTMgMTYuNjg3NCA5LjQzNDI3IDE2LjU1M0wxNi42NDYzIDEyLjk0N0MxNy4xMzczIDEyLjcwMSAxNy4xMzczIDEyLjI5OSAxNi42NDYzIDEyLjA1M0w5LjQzNDI3IDguNDQ2MDNaIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgVideoPlay as ReactComponent };